import flatten from 'flat';
import ms from 'ms';
const getDateDepend = (form,date_depend_field)=>{

const flatten_form = flatten(form)
const found = Object.keys(flatten_form).find(key=>flatten_form[key]===date_depend_field);
const fieldName = found.replace('field_id','field_value');
return (flatten_form.hasOwnProperty(fieldName)) ? (flatten_form[found.replace('field_id','field_value')]):new Date();
        
}


const getMinMaxDate = (date_depend,unit,min,max)=>{
    const minsec = ms(min+unit);
    const maxsec = ms(max+unit);
   
    const min_date = new Date(+new Date(date_depend)-minsec);
    const max_date = new Date(+new Date(date_depend)+maxsec);
    return {min_date,max_date}
}
export {getDateDepend,getMinMaxDate}